<template>
  <div class="wrap" ref="wrap">
    <a-space direction="vertical" style="width:100%" size="middle">
      <a-row type="flex">
        <a-space>
          <a-space>
            <span>姓名: </span>
            <a-input placeholder="输入用户名模糊查询" style="width: 200px" v-model="fuzzyMap.name" @keyup.enter.native="search" />
          </a-space>
          <a-space>
            <span>手机号: </span>
            <a-input placeholder="输入手机号模糊查询" style="width: 200px" v-model="fuzzyMap.phoneNum" @keyup.enter.native="search" />
          </a-space>
          <a-space>
            <a-button type="primary" @click="search">搜索</a-button>
            <a-button type="primary" @click="reset">重置</a-button>
            <a-button type="primary" @click="openDeleteModal">删除</a-button>
            <a-button v-if="showSetting" type="primary" @click="setting">咨询号码设置</a-button>
          </a-space>
        </a-space>
      </a-row>

      <a-table :columns="columns" :data-source="data" size="small" :scroll="tableScroll" :rowKey="(record) => record.id" 
      :loading="loading" :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" :pagination="false">
        <template slot="dealStatus" slot-scope="render">
          <a-tag :color="render == 1 ? 'green' : 'red'">
            {{ render==1 ? "已处理" : "未处理" }}
          </a-tag>
        </template>

        <div slot="action" slot-scope="render">
          <a @click="updateDealStatus(render.id, render.dealStatus)">完成</a>
        </div>
        <!-- <a-row slot="footer" type="flex" justify="end">
          <a-pagination v-model="page" :page-size-options="pageSizeOptions" :total="total" :show-total="(total) => `共 ${total} 个用户`" show-size-changer :page-size="pageSize" @showSizeChange="onShowSizeChange" @change="pageChange" size="small">
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row> -->
        <a-row slot="footer" type="flex" justify="end">
          <a-pagination v-model="page" :page-size-options="pageSizeOptions" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" show-size-changer :page-size="pageSize"
            @showSizeChange="onShowSizeChange" @change="pageChange" size="small">
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row>
      </a-table>
    </a-space>
    <a-modal v-model="setNumModel" title="咨询号码设置">
      <a-form-model ref="createUserForm" :model="projectForm" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        
        <a-form-model-item label="科目名称">
          <a-select placeholder="请选择科目" :value="projectForm.id" @change="changeProject">
            <a-select-option :value="item.id || item.name" v-for="item in projectList" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="咨询号码" required prop="phoneNum">
          <a-input v-model="projectForm.phoneNum" :maxLength="11"/>
        </a-form-model-item>
      </a-form-model>

      <div slot="footer">
        <a-button type="primary" :loading="sumbitLoading" @click="updateConsultNum()">确认</a-button>
      </div>
    </a-modal>
    <a-modal v-model="showDeleteModal" @ok="deleteConsult()">
      <p>是否确认删除该咨询信息？</p>
    </a-modal>
  </div>
</template>

<script>
import { consult, project } from '@/request/api.js';
import { mapState } from "vuex"

const columns = [
  {
    title: '序号',
    dataIndex: "index",
    align: 'center',
    width: '50px',
    customRender:(text, render, index) => `${index + 1}`
  },
  {
    title: '用户名',
    dataIndex: 'name',
    align: 'center',
    width: '100px',
  },
  {
    title: '手机号',
    dataIndex: 'phoneNum',
    width: '120px',
    align: 'center',
  },
  {
    title: '咨询内容',
    dataIndex: 'content',
    width: '150px',
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: '100px',
    align: 'center'
  },
  {
    title: '操作人',
    dataIndex: 'staffName',
    width: '100px',
    align: 'center'
  },
  {
    title: '处理时间',
    dataIndex: 'dealTime',
    width: '100px',
    align: 'center'
  },
  {
    title: '处理状态',
    dataIndex: 'dealStatus',
    align: 'center',
    width: '100px',
    scopedSlots: { customRender: 'dealStatus' },
  },
  {
    title: '操作',
    key: 'operation',
    width: '50px',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  data() {
    return {
      data: [],
      columns,
      loading: false,
      fuzzyMap:{
        'name':'',
        'phoneNum':''
      },
      page: 1,
      pageSize: 10,
      tableScroll: {},
      total: 0,
      pageSizeOptions: ['10', '20', '50'],
      projectForm: {},
      rules: {
        phoneNum: [
          { required: true, message: "请填写咨询号码", trigger: "change" }
        ]
      },
      sumbitLoading: false,
      setNumModel: false,
      selectedRowKeys: [],
      projectList:[],
      showDeleteModal:false,
      showSetting: false
    };
  },
  created() {},
  mounted() {
    this.findConsult();
    this.loadParentProject();
    if (this.userInfo.staffLevel == 1) {
      this.showSetting = true;
    }
    this.tableScroll = {
      y: document.body.clientHeight - 280,
    };
  },
  methods: {
    findConsult() {
      this.loading = true;
      let params = {};
      if (this.page < 1) {
        this.page = 1;
      }
      params.fuzzyMap = this.fuzzyMap;
      params.page = this.page - 1;
      params.size = this.pageSize;

      consult.findConsult(params)
        .then((response) => {
          let total = response.total;
          let data = response.data;
          let loading = false;
          Object.assign(this, {
            data,
            total,
            loading,
          });
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
    },


    /**
     * 查询可授权的科目信息
     */
     loadParentProject() {
      project.queryParent()
        .then((projectList) => {
          Object.assign(this, {
            projectList
          })
        })
    },

    search() {
      this.findConsult();
    },
    reset() {
      let fuzzyMap = {
        'name':'',
        'phoneNum':''
      }
      Object.assign(this, {
        fuzzyMap,
      });
      this.search();
    },

    /**
     * 更新状态为已完成
     * @param {*} render 会员信息
     */
    updateDealStatus(id, dealStatus) {
      if (dealStatus == 1) {
        this.$message.warn("该咨询数据已被处理，不可重复处理")
        return;
      }
      let params = {};
      params.staffId = this.userInfo.id;
      params.staffName = this.userInfo.name;
      params.id = id;
      consult.updateInfo(params)
        .then(() => {
          this.$message.success("处理完成")
          this.findConsult();
        })
        .catch((e) => {
          console.error(e);
        });
    },
    setting() {
      this.setNumModel = true;
      let projectForm = {};
      Object.assign(projectForm, this.projectList[0]);
      this.projectForm = projectForm;
      // consult.queryConsultNum()
      //   .then((projectForm) => {
      //     console.log("projectForm=",projectForm);
      //     Object.assign(this, {projectForm})
      //   })
      //   .catch((e) => {
      //     this.$message.error(e)
      //   });
    },
    updateConsultNum() {
      if (this.projectForm.phoneNum.length != 11) {
        this.$message.warn("咨询电话需要为11位")
        return;
      }
      project.updatePhoneNum(this.projectForm.id, this.projectForm.phoneNum)
        .then(() => {
          this.setNumModel = false;
          this.loadParentProject()
          this.$message.success("设置咨询电话成功");
        })
        .catch((e) => {
          this.$message.error(e)
        });
    },
    onShowSizeChange(page, pageSize) {
      this.page = page;
      this.pageSize = pageSize;
      this.findConsult();
    },
    pageChange() {
      this.findConsult();
    },
    /**
     * 勾选复选框
     * @param {*} selectedRowKeys 
     */
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      console.log("selectedRowKeys", this.selectedRowKeys)
    },
    /**
     * 打开删除信息提示窗口
     */
     openDeleteModal() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warn('请选中需要删除的咨询信息');
      } else {
        this.showDeleteModal = true
      }
    },
    deleteConsult() {
      consult.delete(this.selectedRowKeys)
      .then(() => {
        this.$message.success("删除成功")
        this.showDeleteModal = false
        this.findConsult()
      })
    },
    /**
     * 选择科目授权
     */
     changeProject(projectId) {
      // let staffForm = this.staffForm;
      this.projectForm = this.projectList.filter((item) => item.id == projectId)[0];
      // staffForm.projectId = projectInfo.id;
      // staffForm.projectName = projectInfo.name;
      // Object.assign(this, {
      //   staffForm
      // })
      console.log("projectId",projectId)
    },
  },
  computed: {
    ...mapState(["token", "userInfo"])
  }
};
</script>

<style lang="stylus" scoped>
.wrap {
  display: flex;
}
</style>
